import { render } from "./EmojiLayer.vue?vue&type=template&id=5ce191a4"
import script from "./EmojiLayer.vue?vue&type=script&lang=js"
export * from "./EmojiLayer.vue?vue&type=script&lang=js"

import exportComponent from "D:\\JSD\\03. 사이트\\JSD_SITE\\clientapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__